export const enum UserGroup {
  T0 = "T0",
  T1 = "T1",
  T2 = "T2",
  T3 = "T3",
}

export interface IUser {
  id: string | null;
  email: string | null;
  name: string | null;
  userGroup: UserGroup;
}
